<template>
  <div>
    <div v-if="loadingStarted">
      <Loading></Loading>
    </div>
    <div v-else-if="loadingSuccessful">
      <SurveyContainer></SurveyContainer>
    </div>
    <div v-else-if="failedToLoad">
      <div class="centered-row">
        <ErrorPage>
          <div slot="header">{{notFoundHeader}}</div>
          <div slot="message">{{messageNotFound}}</div>
        </ErrorPage>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    GET_SURVEY,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_STARTED,
    SET_SURVEY_PREVIEW
  } from "../../services/constants"
    import SurveyContainer from "./SurveyContainer"
  import ErrorPage from "../views/ErrorPage"

    export default {
      name: "SurveyActual",
      components: {ErrorPage, SurveyContainer},
      created() {
        this.$store.commit(SET_SURVEY_PREVIEW, false)
        this.$store.dispatch(GET_SURVEY, this.$route.params.survey_id)
      },

      computed: {
        loadingStarted(){
          return this.$store.state.surveyModule.survey.loadingState === LOADING_STARTED
        },
        loadingSuccessful(){
          return this.$store.state.surveyModule.survey.loadingState === LOADING_COMPLETED_SUCCESS
        },
        failedToLoad() {
          return this.$store.state.surveyModule.survey.loadingState === LOADING_COMPLETED_FAILURE
        },
        notFoundHeader() {
          return 'NOT FOUND'
        },
        messageNotFound() {
          return 'Survey not found'
        },

      }
    }
</script>

<style scoped>

</style>
